import React from "react";

function PricePlan() {
  return (
    <div>
      <section className="price-plan-wrapper bg-secondary">
        <div className="divider"></div>

        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="section-heading text-center">
                <div className="sub-title justify-content-center">
                  <img src="assets/img/core-img/hammer.png" alt="" />
                  Pricing Plan
                </div>
                <h2>Our Lawyers HourlyFees</h2>
              </div>
            </div>
          </div>

          <div className="row g-4 align-items-center">
            <div className="col-12 col-md">
              <div className="price-card">
                {/* Single Item */}
                <div
                  className="single-price-item wow fadeInUp"
                  data-wow-delay="300ms"
                  data-wow-duration="1000ms"
                >
                  <div>
                    <div>Contentious Probate</div>
                    <p className="mb-0">
                      Sed blandit libero volutpat sed cras ornare arcu dui
                      vivamus. Pharetra massa ultricies hendrerit.
                    </p>
                  </div>
                  <div className="price-value">$12.00</div>
                </div>

                {/* Single Item */}
                <div
                  className="single-price-item wow fadeInUp"
                  data-wow-delay="400ms"
                  data-wow-duration="1000ms"
                >
                  <div>
                    <div>Employement Law</div>
                    <p className="mb-0">
                      Sed blandit libero volutpat sed cras ornare arcu dui
                      vivamus. Pharetra massa ultricies hendrerit.
                    </p>
                  </div>
                  <div className="price-value">$24.00</div>
                </div>

                {/* Single Item */}
                <div
                  className="single-price-item wow fadeInUp"
                  data-wow-delay="500ms"
                  data-wow-duration="1000ms"
                >
                  <div>
                    <div>Protection Law</div>
                    <p className="mb-0">
                      Sed blandit libero volutpat sed cras ornare arcu dui
                      vivamus. Pharetra massa ultricies hendrerit.
                    </p>
                  </div>
                  <div className="price-value">$48.00</div>
                </div>

                {/* Single Item */}
                <div
                  className="single-price-item wow fadeInUp"
                  data-wow-delay="600ms"
                  data-wow-duration="1000ms"
                >
                  <div>
                    <div>Financial Law</div>
                    <p className="mb-0">
                      Sed blandit libero volutpat sed cras ornare arcu dui
                      vivamus. Pharetra massa ultricies hendrerit.
                    </p>
                  </div>
                  <div className="price-value">$52.00</div>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-3">
              <div className="price-card">
                <img src="assets/img/bg-img/54.png" alt="" />
              </div>
            </div>

            <div className="col-12 col-md">
              <div className="price-card">
                {/* Single Item */}
                <div
                  className="single-price-item wow fadeInUp"
                  data-wow-delay="300ms"
                  data-wow-duration="1000ms"
                >
                  <div>
                    <div>Criminal Law</div>
                    <p className="mb-0">
                      Sed blandit libero volutpat sed cras ornare arcu dui
                      vivamus. Pharetra massa ultricies hendrerit.
                    </p>
                  </div>
                  <div className="price-value">$22.00</div>
                </div>

                {/* Single Item */}
                <div
                  className="single-price-item wow fadeInUp"
                  data-wow-delay="400ms"
                  data-wow-duration="1000ms"
                >
                  <div>
                    <div>Family Law</div>
                    <p className="mb-0">
                      Sed blandit libero volutpat sed cras ornare arcu dui
                      vivamus. Pharetra massa ultricies hendrerit.
                    </p>
                  </div>
                  <div className="price-value">$32.00</div>
                </div>

                {/* Single Item */}
                <div
                  className="single-price-item wow fadeInUp"
                  data-wow-delay="500ms"
                  data-wow-duration="1000ms"
                >
                  <div>
                    <div>Aviation Lawyers</div>
                    <p className="mb-0">
                      Sed blandit libero volutpat sed cras ornare arcu dui
                      vivamus. Pharetra massa ultricies hendrerit.
                    </p>
                  </div>
                  <div className="price-value">$42.00</div>
                </div>

                {/* Single Item */}
                <div
                  className="single-price-item wow fadeInUp"
                  data-wow-delay="600ms"
                  data-wow-duration="1000ms"
                >
                  <div>
                    <div>Business Defence</div>
                    <p className="mb-0">
                      Sed blandit libero volutpat sed cras ornare arcu dui
                      vivamus. Pharetra massa ultricies hendrerit.
                    </p>
                  </div>
                  <div className="price-value">$57.00</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="divider"></div>
      </section>
    </div>
  );
}

export default PricePlan;
